export default "__VITE_ASSET__DqdAlKrX__"